import {Component, OnInit} from '@angular/core';
import {Service} from '../../../../../Models/service';
import {ServiceService} from '../../../../../Services/service.service';

@Component({
  selector: 'app-our-data-service',
  templateUrl: './our-data-service.component.html',
  styleUrls: ['./our-data-service.component.scss']
})
export class OurDataServiceComponent implements OnInit {
servicesData: Service[] = [];

constructor(private servicesService: ServiceService) {
}

ngOnInit(): void {
    this.servicesService.getAllServices().subscribe(services => {
        console.log(services);
        this.servicesData = services;
    });
}

}
